<app-calendar-header [(view)]="view" [(viewDate)]="viewDate"
(currentMonth)="getCurrentMonth()"
(nextMonth)="getNextMonthRecords()"
(previousMonth)="getPreviousMonth()">
</app-calendar-header>

<ng-template #customCellTemplate let-day="day" let-locale="locale">
  <div class="cal-cell-top">
    <span class="cal-day-badge" style="background-color: var(--main-orange);" *ngIf="day.badgeTotal > 0">
      {{ printEventsTotal(day) }}
    </span>

    <span class="cal-day-badge" style="background-color: #12e61c;" *ngIf="day.badgeTotal > 0 && printPrivateEventsTotal(day) > 0">
      {{ printPrivateEventsTotal(day) }}
    </span>

    <span class="cal-day-number"
      >{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span
    >
  </div>
  <div class="cell-totals">
    <span
      *ngFor="let group of day.eventGroups"
      class="badge badge-{{ group[0] }}"
    >
      {{ group[1].length }}
    </span>
  </div>
</ng-template>

<ng-template
  #customEventTemplate
  let-weekEvent="weekEvent"
  let-tooltipPlacement="tooltipPlacement"
  let-eventClicked="eventClicked"
  let-tooltipTemplate="tooltipTemplate"
  let-tooltipAppendToBody="tooltipAppendToBody"
  let-tooltipDisabled="tooltipDisabled"
  let-tooltipDelay="tooltipDelay"
  let-column="column"
>
  <ng-template #groupedEventsTemplate>
    <div style="min-width: 150px;">
      <div *ngFor="let event of weekEvent.event.meta.groupedEvents">
        <mwl-calendar-event-actions [event]="event">
        </mwl-calendar-event-actions>
        <mwl-calendar-event-title [event]="event" view="week">
        </mwl-calendar-event-title>
      </div>
    </div>
  </ng-template>

   <div
    [ngbPopover]="groupedEventsTemplate"
    [disablePopover]="!weekEvent.event.meta.groupedEvents"
    class="cal-event"
    [ngStyle]="{
          backgroundColor: 'weekEvent.event.color?.secondary',
          borderColor: weekEvent.event.color?.primary
        }"
    [mwlCalendarTooltip]="
          !tooltipDisabled && !weekEvent.event.meta.groupedEvents
            ? (weekEvent.event.title
              | calendarEventTitle: 'weekTooltip':weekEvent.event)
            : ''
        "
    [tooltipPlacement]="tooltipPlacement"
    [tooltipEvent]="weekEvent.event"
    [tooltipTemplate]="tooltipTemplate"
    [tooltipAppendToBody]="tooltipAppendToBody"
    [tooltipDelay]="tooltipDelay"
    (mwlClick)="eventClicked.emit()"
  >
    <ng-container *ngIf="!weekEvent.event.meta.groupedEvents">
      <mwl-calendar-event-actions [event]="weekEvent.event">
      </mwl-calendar-event-actions>
    </ng-container>
    <mwl-calendar-event-title [event]="weekEvent.event" view="week">
    </mwl-calendar-event-title>
  </div>
</ng-template>

<ng-template #customOpenDayEventsTemplate let-events="events" let-eventClicked="eventClicked" let-day="day" let-isOpen="isOpen">
  <div class="cal-open-day-events" [@collapse] *ngIf="isOpen">
    <div
          *ngFor="let event of events; let i = index;"
          [ngClass]="event?.cssClass"
          mwlDraggable
          [class.cal-draggable]="event.draggable"
          dragActiveClass="cal-drag-active"
          [dropData]="{ event: event }"
          [dragAxis]="{ x: event.draggable, y: event.draggable }"
          [touchStartLongPress]="{ delay: 300, delta: 30 }"
        >
          <span
            class="cal-event"
            [ngStyle]="{ backgroundColor: event.color?.primary }"
          >
          </span>
          <mwl-calendar-event-title
            [event]="event"

            view="month"
            (mwlClick)="
              handleEvent(event, i);
            "
            (mwlKeydownEnter)="
              eventClicked.emit({ event: event, sourceEvent: $event })
            "
            tabindex="0"

          >
          </mwl-calendar-event-title>
          <mwl-calendar-event-actions
            [event]="event"

          >
          </mwl-calendar-event-actions>
          <div class="mt-1" [@collapse] *ngIf="isDetailToggled[i]">
              <mat-chip-list aria-label="Fish selection">
                <div class="mb-2"  *ngFor="let record of dailyEvents(event);">
                  <mat-chip *ngIf="record" [style.background-color]="setChipsBackgroundColorByCausale(event.title)" selected>
                    <a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: getIsinStringForSchedaCertificato(record) }">
                      <strong>{{record}}</strong>
                    </a>

                    <button
                      mat-icon-button
                      [disableRipple]="true"
                      matTooltip="Visualizza Portafogli"
                      matTooltipPosition="after"
                      *ngIf="event.title.toUpperCase().includes('Personal: '.toUpperCase())"
                      (click)="onShowPortfolios(record)"
                    >
                      <mat-icon>account_balance_wallet</mat-icon>
                    </button>
                  </mat-chip>
                </div>
              </mat-chip-list>
          </div>
        </div>
      </div>

    </ng-template>

<div [ngSwitch]="view">
  <mwl-calendar-month-view
    *ngSwitchCase="'month'"
    [openDayEventsTemplate]="customOpenDayEventsTemplate"
    [viewDate]="viewDate"
    [events]="events"
    [cellTemplate]="customCellTemplate"
    (beforeViewRender)="beforeMonthViewRender($event)"
    (dayClicked)="dayClicked($event.day)"
    (eventTimesChanged)="eventTimesChanged($event)"
    [refresh]="refresh"
    [activeDayIsOpen]="activeDayIsOpen"
  >
  </mwl-calendar-month-view>
  <mwl-calendar-week-view
    *ngSwitchCase="'week'"
    [viewDate]="viewDate"
    [events]="groupedSimilarEvents"
    [eventTemplate]="customEventTemplate"
  >
  </mwl-calendar-week-view>
  <mwl-calendar-day-view
    *ngSwitchCase="'day'"
    [viewDate]="viewDate"
    [events]="groupedSimilarEvents"
    [eventTemplate]="customEventTemplate"
  >
  </mwl-calendar-day-view>
  <div [ngClass]="store.showLoader ? 'd-flex justify-content-center loading' : 'd-flex justify-content-center'">
    <app-loader *ngIf="store.showLoader"></app-loader>
  </div>
</div>
